export default __webpack_public_path__ + "static/media/sort.3fc12aa7.svg";